export default __webpack_public_path__ + "static/media/home3.5c8d917a.jpg";